import React, { useState } from 'react'
import {
  Typography,
  Chip,
  Divider,
  Menu,
  MenuItem,
  IconButton
} from '@material-ui/core'
import LinkRoundedIcon from '@material-ui/icons/LinkRounded'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import { renderLongText } from 'helpers/dataHelpers'
import history from 'browserHistory'
import RowLink from 'components/RowLink'
import useStyles from './styles'


const DocumentListItem = (props) => {
  const {
    id,
    name,
    file,
    advices,
    isAdvice,
    isMobile,
    handleListItemChange
  } = props
  const localClasses = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event) => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const handleRemoveFromList = (event) => {
    event.stopPropagation()
    setAnchorEl(null)
    handleListItemChange('remove', {id})
  }

  const renderAdviceNames = (advicesList) => {
    if (!advicesList || advicesList.length === 0) {
      return <Typography variant='body1'>No related</Typography>
    } else {
      return advicesList.map((advice, index) =>
        <Chip
          key={advice.id}
          label={renderLongText(advice.title, isMobile ? 12 : null)}
          className={localClasses.adviceChip}
          icon={<LinkRoundedIcon />}
          onClick={(event) => {
            event.stopPropagation()
            history.push(`/advices/${advice.id}`)
          }}
        />
      )
    }
  }

  return (
    <>
      <RowLink
        id={id}
        className={localClasses.document}
        href={file}
      >
        <div className={localClasses.title}>
          <Typography variant='body2' noWrap className={localClasses.fullWidth}>
            {name}
          </Typography>
        </div>
        {
          !isAdvice &&
          <div className={localClasses.advices}>
            {renderAdviceNames(advices)}
          </div>
        }
        {
          handleListItemChange ?
            <>
              <div
                className={localClasses.actions}
              >
                <IconButton
                  aria-controls={`document-${id}-menu`}
                  aria-haspopup='true'
                  onClick={handleClick}
                  className={localClasses.formControl}
                >
                  <MoreHorizIcon />
                </IconButton>
                <Menu
                  id={`document-${id}-menu`}
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleRemoveFromList}>Remove from list</MenuItem>
                </Menu>
              </div>
            </> : null
        }
      </RowLink>
      <Divider />
    </>
  )
}

export default DocumentListItem
